export default "__VITE_ASSET__77361815__"